var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.196348 11.7652C0.341104 11.9211 0.537755 12.0001 0.735007 12C0.913876 12 1.09318 11.9351 1.23459 11.8038L6.90815 6.53849C7.05801 6.39942 7.14314 6.20437 7.14314 5.99998C7.14314 5.79559 7.05801 5.60041 6.90815 5.46147L1.23459 0.19618C0.937207 -0.0797735 0.47232 -0.0625733 0.196237 0.234957C-0.0798618 0.532343 -0.0625163 0.997229 0.235014 1.27331L5.32827 6.0001L0.235014 10.7269C-0.0625163 11.0028 -0.0798618 11.4677 0.196237 11.7652L0.196348 11.7652Z",
    fill: "#9BAAB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right_icon.291ae49eb293d1e7a401163b3ed5b072.svg";
export { ForwardRef as ReactComponent };